import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/somewhat-dissatisfied-filled.vue
var o = {
	name: "DtIconSomewhatDissatisfiedFilled",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--somewhat-dissatisfied-filled"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Somewhat Dissatisfied Filled",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M.563 6a5.437 5.437 0 1 1 10.874 0A5.437 5.437 0 0 1 .563 6Zm3.5-1.5c0-.242.195-.438.437-.438h.005a.437.437 0 1 1 0 .875H4.5a.437.437 0 0 1-.438-.437Zm3 0c0-.242.195-.438.437-.438h.005a.437.437 0 1 1 0 .875H7.5a.437.437 0 0 1-.438-.437Zm-1.84 2.938c-.37 0-.73.121-1.025.346l-.082.064a.438.438 0 0 1-.532-.696l.083-.063a2.563 2.563 0 0 1 1.556-.527h1.508c.598 0 1.178.21 1.638.593l.01.009a.437.437 0 1 1-.559.672l-.01-.008a1.688 1.688 0 0 0-1.08-.39H5.225Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=somewhat-dissatisfied-filled.js.map